import { Context, createElement, Fragment, FunctionComponent } from 'react';

export interface ContextPair {
  context: Context<any>;
  value: any;
}

export interface MultiProviderProps {
  children?: any;
  contextPairs: ContextPair[];
}

export const MultiContextProvider: FunctionComponent<MultiProviderProps> = ({ contextPairs, children }) => {
  if (!contextPairs || !Array.isArray(contextPairs) || contextPairs.length === 0) {
    return createElement(Fragment, null, children);
  }

  const { context, value } = contextPairs[0];

  return createElement(context.Provider, { value }, createElement(MultiContextProvider, { contextPairs: contextPairs.slice(1) }, children));
};
MultiContextProvider.displayName = 'MultiContextProvider';
